import CreatePortalCard from "./CreatePortalCard";

export default CreatePortalCard;
